import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Sidebar } from "./Sidebar";
import { Loading } from "../shared/Loading";
import { authApi } from "./services/authServices";
export const ProtectedRoute = () => {
  const [isValidSession, setIsValidSession] = useState<boolean | null>(null);
  // extract token to verify
  useEffect(() => {
    const checkSession = async () => {
      const validSession = await authApi.verifySession();
      setIsValidSession(validSession);
    };
    void checkSession();
  }, []);
  if (isValidSession === null) {
    return <Loading />;
  }

  if (isValidSession) {
    return <Sidebar />;
  } else {
    return <Navigate to="/auth" />;
  }
};
